module.exports = __webpack_public_path__ + "01ec3194a89e6a0c56765a04410c2461.svg";